export const trackGtmEvent = (event, payload = {}) => {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    ...payload,
    event,
    anonymize_ip: true,
  })
}
